export default __webpack_public_path__ + "static/media/close.0bbc5d86.svg";